import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import api from '@/services/app-config/api';
import { useAtomicSetter } from '@/composables/useAtomicSetter.js';

export const useAppConfigStore = defineStore('appConfig', () => {
  const isConfigured = ref(false);
  const config = ref({
    a: null,
    b: null,
    c: null,
    d: null,
    e: false,
    f: null,
    g: null,
    h: null,
  });

  const vars = computed(() => {
    return {
      AUTH0_SUPPLIER_SPA_CLIENT_ID: config.value.a,
      AUTH0_SUPPLIER_DOMAIN: config.value.b,
      AUTH0_SUPPLIER_IDENTIFIER: config.value.c,
      AIRWALLEX_CLIENT_ID: config.value.d,
      AIRWALLEX_API_ENV: config.value.e,
      ENABLE_SENTRY: config.value.f,
      RELEASE: config.value.g,
      ENVIRONMENT: config.value.h,
    };
  });

  const stateRefs = {
    config,
    isConfigured,
  };

  const { setAtomic } = useAtomicSetter(stateRefs);

  const getConfig = async (params = { init: 'false' }) => {
    const configData = await api.getConfig(params);
    config.value = configData;
    if (params.init === 'true') {
      isConfigured.value = true;
    }
  };

  const isProduction = computed(() => vars.value.ENVIRONMENT === 'production');
  const isStaging = computed(() => vars.value.ENVIRONMENT === 'staging');

  return {
    ...stateRefs,
    vars,
    isProduction,
    isStaging,
    getConfig,
    setAtomic,
  };
});
